module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/wbs-element-remarks/wbs-element-remarks.component.css
// module id = ./src/app/wbs-element-remarks/wbs-element-remarks.component.css
// module chunks = main